import React from "react";
import { motion } from "framer-motion";
import { easyonWorkflowSteps } from "../../data/easyonPageContent";
import { EasyonReveal } from "./EasyonMotion";

export const EasyonWorkflowSection = () => (
    <section className="eo-workflow">
        <div className="eo-container">
            <EasyonReveal className="eo-workflow__header">
                <span className="eo-eyebrow eo-eyebrow--light">Business Workflow</span>
                <h2 className="eo-h2 eo-h2--light">From Inquiry to Compliance</h2>
                <p className="eo-lead eo-lead--light">
                    A seamless end-to-end workflow that connects every stage of your business operations.
                </p>
            </EasyonReveal>

            <div className="eo-workflow__track-wrap">
                <div className="eo-workflow__line" />
                <motion.div
                    className="eo-workflow__pulse"
                    animate={{ left: ["0%", "100%"] }}
                    transition={{ duration: 7, repeat: Infinity, ease: "linear" }}
                />
                <div className="eo-workflow__timeline">
                    {easyonWorkflowSteps.map((step, i) => (
                        <motion.div
                            key={step}
                            className="eo-workflow__step"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ delay: i * 0.08, duration: 0.5 }}
                        >
                            <div className="eo-workflow__node">
                                <span>{i + 1}</span>
                                <p>{step}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
